import PropTypes from 'prop-types';

var propTypes = {
    leftElement: PropTypes.node,
    centerElement: PropTypes.node,
    rightElement: PropTypes.node,
    alignTitle: PropTypes.oneOf(['center', 'left']),
    variant: PropTypes.oneOf(['aqua', 'dark', 'light']),
    dark: PropTypes.bool,
    truncateOnScroll: PropTypes.bool,
    truncateOnScrollTarget: PropTypes.instanceOf(Element),
    onTruncateChange: PropTypes.func,
};
var defaultProps = {
    dark: false,
    alignTitle: 'center',
    variant: 'light',
    truncateOnScroll: false,
    truncatedMaxHeight: '44px',
};

export { defaultProps, propTypes };
